/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { useSelector, useDispatch } from 'react-redux';
import {
  reviewCorrectionDropdown,
  reviewProblemDropdown,
  dispatchcorrectionCode,
  dispatchBottonState,
} from '../Store/actions';
export default (props) => {
  const getCorrectionCode = useSelector(
    (state) => state.sharedState.ProviderReviewReducer?.getCorrectionCode
  );
  const getCorrectionCodeDropdown = useSelector(
    (state) => state.sharedState.ProviderReviewReducer?.reviewCorrectionDropdown
  );
  const dispatch = useDispatch();
  const getDetailDatainTable = useSelector(
    (state) => state.sharedState.ProviderReviewReducer?.getDetailData
  );

  return (
    <div data-testid='correction-code-select-box'>
      <TextField
        data-testid='correct-code'
        fullWidth
        select
        placeholder=''
        tabIndex={10}
        InputProps={{ inputProps: { tabIndex: 10 } }}
        InputLabelProps={{
          shrink: true,
        }}
        value={getCorrectionCode ? getCorrectionCode : props.cellInfo.value}
        disabled={
          getDetailDatainTable?.formValue?.completeIndex ||
          !props.isEnablebyRole
        }
        onChange={(e) => {
          dispatch(dispatchBottonState(false));
          dispatch(dispatchcorrectionCode(e.target.value));
          props.cellInfo.node.setDataValue(
            props.cellInfo.column.colId,
            e.target.value
          );
        }}
      >
        {props.correctionDropDownReview &&
        props.correctionDropDownReview &&
        props.correctionDropDownReview.length > 0
          ? props.correctionDropDownReview.map((item) => {
              return (
                <MenuItem
                  key={item.codeValueID && item.codeValueID.codeValue}
                  value={item.codeValueID && item.codeValueID.codeValue}
                >
                  {item.codeValueID.codeValue} {'|'} {item.shortDescription}
                </MenuItem>
              );
            })
          : null}
      </TextField>
    </div>
  );
};
